import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import moment from 'moment';
import './style.css';
import { FormattedMessage, intlShape, injectIntl, defineMessages } from 'react-intl';
const messages = defineMessages({
  add: {
    id: 'SH_Add',
    defaultMessage: '新增',
  },
  cancel: {
    id: 'SH_Cancel02',
    defaultMessage: '取消',
  },
  approval: {
    id: 'SH_PendingForApproval',
    defaultMessage: '審核中',
  },
  return: {
    id: 'SH_Rejected',
    defaultMessage: '退回',
  },
  finish: {
    id: 'FD_ReviewCompletedUpdate',
    defaultMessage: '審核完成已更新',
  },
  edit: {
    id: 'SH_Modify',
    defaultMessage: '修改',
  },
  delete: {
    id: 'SH_Delete',
    defaultMessage: '刪除',
  },
});
class ChangeRecord extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpened: false,
    };
    this.toggleChangeRecord = this.toggleChangeRecord.bind(this);
  }

  getStatueString(status, rejectReason) {
    switch (status) {
      case '10':
        return this.props.intl.formatMessage(messages.add);
      case '30':
        return this.props.intl.formatMessage(messages.cancel);
      case '40':
        return this.props.intl.formatMessage(messages.approval);
      case '50':
        return <span>{this.props.intl.formatMessage(messages.return)}<i className="fa fa-long-arrow-right"></i> {rejectReason}</span>;
      case '99':
        return this.props.intl.formatMessage(messages.finish);
      default:
        return this.props.intl.formatMessage(messages.finish);
    }
  }

  getAactionString(action) {
    switch (action) {
      case 'POST':
        return this.props.intl.formatMessage(messages.add);
      case 'PUT':
        return this.props.intl.formatMessage(messages.edit);
      case 'Delete':
        return this.props.intl.formatMessage(messages.delete);
      default:
        return '';
    }
  }

  toggleChangeRecord() {
    this.setState({
      'isOpened': !this.state.isOpened,
    });
  }

  render() {
    return (
      <div className="change-record">
        <div className="change-record-info">
          <span className="change-record-date">
            {this.props.date && moment(this.props.date).format('YYYY/MM/DD')} {this.props.title}
          </span>
          <span>
            {this.getAactionString(this.props.action)}
          </span>
          <span className="change-record-status">
            ( <FormattedMessage id="FD_ApplicationStatus" defaultMessage="申請狀態" />: { this.getStatueString(this.props.status, this.props.rejectReason) } )
          </span>
          <span className="pull-right change-record-action-group">
            {
              this.props.status === '10' &&
                <i className="fa fa-trash" onClick={this.props.onDelete}></i>
            }
            <i
              className={
                classNames({
                  'fa': true,
                  'fa-chevron-circle-up': this.state.isOpened,
                  'fa-chevron-circle-down': !this.state.isOpened,
                })
              }
              onClick={this.toggleChangeRecord}
            >
            </i>
          </span>
        </div>
        <div
          className={
            classNames({
              'change-record-detail': true,
              'open': this.state.isOpened,
            })
          }
        >
          {this.props.children}
        </div>
      </div>
    );
  }
}

ChangeRecord.propTypes = {
  children: PropTypes.object,
  date: PropTypes.string,
  title: PropTypes.string,
  status: PropTypes.string,
  rejectReason: PropTypes.string,
  onDelete: PropTypes.func.isRequired,
  action: PropTypes.string,
  intl: intlShape.isRequired,
};

export default injectIntl(ChangeRecord);



/** WEBPACK FOOTER **
 ** D:/a/1/s/Tube.Frontend/src/containers/App/screens/Foundation/screens/MyData/components/ChangeRecord/index.js
 **/